import gql from 'graphql-tag';

export const SystemPrintAssetImages = gql`
  query systemPrintAssetImages(
    $print_asset_type: PrintAssetTypeEnum
    $search_query: String
    $pricing_category_ids: [RecordID!]
  ) {
    systemPrintAssets(
      print_asset_type: $print_asset_type
      search_query: $search_query
      pricing_category_ids: $pricing_category_ids
      slice: { limit: 9999 }
    ) {
      total
      records {
        id
        name
        asset_image {
          id
          url
        }
        preview_asset_image {
          id
          url
        }
      }
    }
  }
`;

export const SystemPrintAssetGroups = gql`
  query systemPrintAssetGroups($print_asset_group_type: PrintAssetTypeEnum) {
    systemPrintAssetGroups(
      print_asset_group_type: $print_asset_group_type
      slice: { limit: 999 }
    ) {
      total
      records {
        id
        name
        members(slice: { limit: 99 }) {
          total
          records {
            id
            is_primary
            print_asset {
              id
              name
              asset_image {
                id
                url
              }
              preview_asset_image {
                id
                url
              }
              pricing_categories {
                records {
                  id
                  pricing_category {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
